import BrandStoryBand from "components/HomePage/BrandStoryBand";

const TransitionHome = () => (
  <BrandStoryBand
    imageSrc="hannahb-min.jpg"
    imageAlt="Rider on a Transition mountain bike"
    imageObjectPosition={{ xs: "25% center", md: "center" }}
    logoSrc="transitionlogowhite.png"
    logoAlt="Transition Bikes"
    align="right"
    eyebrow="TRANSITION BIKES"
    description="We are proud to be one of the largest Transition Bikes dealers in Canada! Transition is a local company from Bellingham, WA. We are always well stocked in everything Transition offers, from XC to DH."
    shopBrand="Transition"
  />
);

export default TransitionHome;
